export default __webpack_public_path__ + "media/images/corp/nagaoka_2024-71c843d59dd28bae6c9728edcf3361bc.jpg";